import { createRouter, createWebHistory } from "vue-router";
import {
  loadPreviousPage,
  resumeLastPage,
  timeOfLastPage,
} from "@/utils/loadPastPages";
import { currentPageId, replacePage } from "@/utils/pageHistory";
import { startRemix } from "@/utils/remix";
import Home from "../views/Home.vue";
import store from "../store";

const routes = [
  {
    path: "/",
    name: "Home",
    component: Home,
  },
  {
    path: "/s/:shareId",
    name: "Shared",
    component: () =>
      import(/* webpackChunkName: "shared" */ "../views/SharedMake.vue"),
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

// Picks up where the visitor was when the app first loads. Back and Forward within the
// app are handled by Home's popstate listener, so this only runs once.
let started = false;
async function start(query) {
  const { remix, auth, wishes, lk: campaignLink } = query;
  store.dispatch("auth/setUserID");
  if (typeof remix === "string" && remix) {
    // "Remix this" on a shared make: carry on from it as a new make
    if (await startRemix(store, remix, { replace: true })) return;
  } else if (wishes) {
    // Back from buying wishes with Stripe
    await resumeLastPage(store);
    store.dispatch("wishes/purchaseReturned", wishes);
    return;
  } else if (auth === "failed" || auth === "success") {
    await resumeLastPage(store);
    store.dispatch(
      auth === "success"
        ? "auth/successfulFederatedLogin"
        : "auth/failedFederatedLogin"
    );
    return;
  } else if (campaignLink) {
    store.dispatch("auth/setCampaignLink", campaignLink);
  }

  // A reload keeps the page it was on
  const pageId = currentPageId();
  if (pageId !== undefined && (await loadPreviousPage(store, pageId))) return;
  // Coming back within 5 minutes carries on from the last page
  const time = await timeOfLastPage();
  if (
    time &&
    Date.now() - time < 5 * 60 * 1000 &&
    (await resumeLastPage(store))
  ) {
    return;
  }
  replacePage(store.state);
}

router.beforeEach(async (to) => {
  // Shared makes stand alone, away from the user's own pages
  if (to.name === "Shared" || started) {
    return true;
  }
  started = true;
  await start(to.query);
  // Tidy the address bar once the query has been used
  if (Object.keys(to.query).length) {
    return { path: to.path, replace: true };
  }
  return true;
});

export default router;
